/* eslint-disable no-console */
import axios from "axios";
import { BaseApi } from "./base-api";
import { AppConfig } from "../config/app-config";
import { getToken } from "../auth-helper";

const resourceKey = "users";

export const UsersApi = {
  list: () => BaseApi.list(resourceKey),
  // 未使用のためコメント化、使用する際はuserusergroup_setに
  // is_deletedのチェックを入れるようにサーバー側でオーバライドする
  // retrieve: (pk: number) => BaseApi.retrieve(resourceKey, pk),
  create: (params: any) => BaseApi.create(resourceKey, params),
  update: (pk: number, params: any) => BaseApi.update(resourceKey, pk, params),
  destroy: (pk: number) => BaseApi.destroy(resourceKey, pk),
  self: (token?: string) => {
    const apiBase = AppConfig.get("apiBase");
    // console.log(`BaseApi apiBase: ${apiBase}`);
    const sendToken = token || getToken();
    // console.log(`BaseApi token: ${sendToken}`);
    const url = `${apiBase}/${resourceKey}/self`;
    // console.log(`BaseApi url: ${url}`);
    return axios.get(url, {
      headers: { 
        Authorization: `JWT ${sendToken}`, 
      },
    });
  },
  selfChangePassword: (password: string, newPassword: string) => {
    const apiBase = AppConfig.get("apiBase");
    // console.log(`BaseApi apiBase: ${apiBase}`);
    const token = getToken();
    // console.log(`BaseApi token: ${token}`);
    const url = `${apiBase}/${resourceKey}/self/change_password/`;
    // console.log(`BaseApi url: ${url}`);
    return axios.post(
      url,
      {
        password,
        new_password: newPassword,
      },
      {
        headers: { Authorization: `JWT ${token}` },
      }
    );
  },
  resetPassword: (pk: number) => {
    const apiBase = AppConfig.get("apiBase");
    // console.log(`BaseApi apiBase: ${apiBase}`);
    const token = getToken();
    // console.log(`BaseApi token: ${token}`);
    const url = `${apiBase}/${resourceKey}/reset_password/`;
    // console.log(`BaseApi url: ${url}`);
    return axios.post(
      url,
      {
        id: pk,
      },
      {
        headers: { Authorization: `JWT ${token}` },
      }
    );
  },
};
